<app-base-template (modal)="openModal(content)" (tabledata)="getTableData()" [displayData]="displayData" [nextOffset]="nextOffset"
                   [previousOffset]="previousOffset" (offset)="getData($event)"
                   (pageSize)="onPageSizeChange($event)" [pageNo]="page_no" [totalPage]="totalPage" [dataLoaded]="dataLoaded"></app-base-template>
<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Add FAQ Category</div>

  </div>
  <div class="modal-body">
    <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
    <div class="form-group">
      <input type="text" class="form-control radius-0 font-13" [(ngModel)]="categoryName"
             placeholder="Category Name">
    </div>
    <div class="form-group">
      <input type="text" class="form-control radius-0 font-13" [(ngModel)]="sequenceNo"
             placeholder="Sequence No">
    </div>
  </div>
  <div class="modal-footer pad-8">
    <button type="button" class="btn btn-success radius-0" (click)="save()">Save</button>
    <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  </div>
</ng-template>
<notifier-container></notifier-container>
